export default __webpack_public_path__ + "static/media/IMG_5004.a901a326.JPG";